import React from "react";
import { NavLink, Navigate, Outlet } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import { useAuth } from "@mhj/shared/auth";
import UserBadge from "@mhj/shared/UserBadge";

export default function AppShell() {
  const { user, logout } = useAuth();
  const queryClient = useQueryClient();

  const handleLogout = async () => {
    // Prevent previously cached applicant data from showing after re-login.
    queryClient.removeQueries({ queryKey: ["scholarship"] });
    await logout();
  };

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-white/10 text-slate-900">
      <header className="sticky top-0 z-20 border-b border-sky-200 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-blue-600">
              Jantabo Scholarship Initiative
            </p>
            <h1 className="text-lg font-semibold text-slate-900">Applicant Portal</h1>
          </div>
          <div className="flex items-center gap-4">
            <UserBadge user={user} />
            <button
              className="rounded-full border border-blue-200 bg-white px-4 py-2 text-xs uppercase tracking-[0.2em] text-slate-600 transition hover:border-blue-400 hover:text-blue-700"
              onClick={() => void handleLogout()}
            >
              Log out
            </button>
          </div>
        </div>
      </header>
      <div className="mx-auto grid max-w-6xl gap-6 px-6 py-8 lg:grid-cols-[240px_1fr]">
        <aside className="glass-card p-4 border-r border-blue-100">
          <nav className="flex flex-col gap-2 text-sm font-medium">
            <NavLink
              to="/portal"
              end
              className={({ isActive }) =>
                `rounded-2xl px-4 py-3 transition ${
                  isActive
                    ? "bg-blue-100 text-blue-700"
                    : "text-slate-600 hover:text-slate-900"
                }`
              }
            >
              Dashboard
            </NavLink>
            <NavLink
              to="/portal/apply"
              className={({ isActive }) =>
                `rounded-2xl px-4 py-3 transition ${
                  isActive
                    ? "bg-blue-100 text-blue-700"
                    : "text-slate-600 hover:text-slate-900"
                }`
              }
            >
              Apply / Uploads
            </NavLink>
          </nav>
        </aside>
        <main className="space-y-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
